import type { PdpDeliveryContext } from '../../domain/models/PdpDeliveryContext';
import type { PdpNearbyStore } from '../../domain/models/PdpNearbyStore';

export interface PdpDeliveryAppVm {
  edd: string | null;
  eddFullDate: string | null;
  sameDayMessage: string | null;
  pincode: string;
  cityName: string | null;
  storeName: string | null;
  contactNumber: string | null;
  whatsappNumber: string | null;
  isDirectContactAllowed: boolean;
  nearbyStoreCount: number;
  inventoryStores: PdpNearbyStore[];
  nearbyStoresList: PdpNearbyStore[];
  designEddDetails: unknown | null;
}

export function toPdpDeliveryAppVm(context: PdpDeliveryContext): PdpDeliveryAppVm {
  const { deliveryInfo, resolvedEdd, storeForCustomization, nearbyStores } = context;
  const nearbyStoresList = Object.values(nearbyStores);

  return {
    edd: resolvedEdd.edd ?? deliveryInfo.edd,
    eddFullDate: resolvedEdd.eddFullDate ?? deliveryInfo.eddFullDate,
    sameDayMessage: resolvedEdd.sameDayMessage,
    pincode: deliveryInfo.pincode,
    cityName: deliveryInfo.cityName,
    storeName: storeForCustomization?.storeName ?? null,
    contactNumber: storeForCustomization?.contactNumber ?? null,
    whatsappNumber: storeForCustomization?.whatsappNumber ?? null,
    isDirectContactAllowed: storeForCustomization?.isDirectContactAllowed ?? false,
    nearbyStoreCount: storeForCustomization?.allNearbyStores.length ?? 0,
    inventoryStores: storeForCustomization?.allNearbyStores ?? [],
    nearbyStoresList,
    designEddDetails: deliveryInfo.designEddDetails,
  };
}
